import React from 'react';
import { CheckIcon, GiftIcon } from 'lucide-react';
import { stack, totalValue } from '../data/offer';
import { PRICE_USD } from '../data/checkout';
import { CtaButton } from './CtaButton';
export function ValueStack() {
  return <section id="offer" className="w-full border-y border-line bg-surface" data-id="element-138" data-mp="1q9o3rbb0tjag">
      <div className="mx-auto max-w-4xl px-5 py-20 sm:px-8 lg:py-28" data-id="element-139" data-mp="1u96ghjsouo27">
        <div className="max-w-2xl" data-id="element-140" data-mp="2hzith92sjazn">
          <p className="font-sans text-xs font-semibold uppercase tracking-[0.22em] text-volt" data-id="element-141" data-mp="2i0k97qur4lnp">
            Today’s offer
          </p>
          <h2 className="mt-4 font-display text-5xl font-extrabold uppercase leading-[0.95] tracking-tightest text-white sm:text-6xl" data-id="element-142" data-mp="2n0q2tckl0i8f">
            Everything you get today
          </h2>
        </div>

        <ul className="mt-12 divide-y divide-line border-y border-line" data-id="element-143" data-mp="2d6pp4mb8i4o3">
          {stack.map(item => <li key={item.label} className="flex flex-wrap items-baseline gap-x-6 gap-y-2 py-5" data-id="element-144" data-mp="30x3icg5k29k9">
              <span className="mt-1 flex h-6 w-6 shrink-0 items-center justify-center self-start bg-volt/15" data-id="element-145" data-mp="35qek42vig05b">
                {item.isBonus ? <GiftIcon className="h-3.5 w-3.5 text-volt" aria-hidden="true" data-id="element-146" data-mp="1oga48d9dd053" /> : <CheckIcon className="h-4 w-4 text-volt" aria-hidden="true" data-id="element-147" data-mp="1oi3b9tnw9mdm" />}
              </span>
              <div className="min-w-0 flex-1" data-id="element-148" data-mp="236halum3qspf">
                <p className="font-display text-2xl font-bold uppercase leading-tight tracking-tightest text-white" data-id="element-149" data-mp="1ydxyl232c5mq">
                  {item.isBonus && <span className="mr-2 text-volt" data-id="element-150" data-mp="2c4jm543gp3qy">Bonus</span>}
                  {item.label}
                </p>
                <p className="mt-1 font-sans text-sm leading-relaxed text-muted" data-id="element-151" data-mp="283zn1uzbvq26">
                  {item.detail}
                </p>
              </div>
              <p className="font-sans text-base font-semibold text-muted line-through" data-id="element-152" data-mp="2h4fqj4g2mx71">
                ${item.value}
              </p>
            </li>)}
        </ul>

        <div className="mt-6 flex items-baseline justify-between" data-id="element-153" data-mp="rrubk8ayqanr">
          <p className="font-sans text-sm font-semibold uppercase tracking-[0.16em] text-muted" data-id="element-154" data-mp="mshd0qaqbf5c">
            Total value
          </p>
          <p className="font-display text-3xl font-bold text-muted line-through" data-id="element-155" data-mp="2mvii7nncnde1">
            ${totalValue}
          </p>
        </div>

        <div className="mt-12 border border-volt bg-ink p-8 text-center sm:p-12" data-id="element-156" data-mp="2vtkreqh8lcce">
          <p className="font-sans text-sm font-semibold uppercase tracking-[0.16em] text-white/70" data-id="element-157" data-mp="30soynbklp003">
            Get the entire system today for only
          </p>
          <p className="mt-3 font-display text-8xl font-extrabold leading-none tracking-tightest text-volt sm:text-9xl" data-id="element-158" data-mp="35pxmnssfjy99">
            ${PRICE_USD}
          </p>
          <p className="mt-3 font-sans text-sm text-muted" data-id="element-159" data-mp="3fiwbnbru9qte">
            One-time payment. Lifetime access.
          </p>
          <div className="mt-8" data-id="element-160" data-mp="3jix25us7psgt">
            <CtaButton className="w-full sm:w-auto" data-id="element-161" data-mp="3oijdfyohcymz" />
          </div>
          <p className="mt-4 font-sans text-xs uppercase tracking-[0.16em] text-muted" data-id="element-162" data-mp="3okcl9hatxowk">
            Immediate access • Secure payment • 7-day guarantee
          </p>
        </div>
      </div>
    </section>;
}